import { Badge } from "@/components/Badge.tsx";
import { Trans } from "@lingui/react/macro";
import type { InvoiceStatus } from "@warrenio/api-spec/spec.oats.gen";
import { InvoiceStatusEnum } from "@warrenio/api-spec/spec/billingEnums";
import { exhaustiveSwitchCheck } from "@warrenio/utils/unreachable";

export function ReportStatus({ value }: { value: InvoiceStatus }) {
    switch (value) {
        case InvoiceStatusEnum.PAID:
            return (
                <Badge color="success">
                    <Trans>Paid</Trans>
                </Badge>
            );

        case InvoiceStatusEnum.UNPAID:
            return (
                <Badge color="error">
                    <Trans>Unpaid</Trans>
                </Badge>
            );

        case InvoiceStatusEnum.IN_PROGRESS:
            return (
                <Badge color="text">
                    <Trans>Ongoing</Trans>
                </Badge>
            );

        default:
            exhaustiveSwitchCheck(value);
    }
}
